import { render, staticRenderFns } from "./ManageImages.vue?vue&type=template&id=0f218230&scoped=true"
import script from "./ManageImages.vue?vue&type=script&lang=js"
export * from "./ManageImages.vue?vue&type=script&lang=js"
import style0 from "./ManageImages.vue?vue&type=style&index=0&id=0f218230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f218230",
  null
  
)

export default component.exports